import { defineStore } from 'pinia'
import { JobService, ResponseError } from '@/services/app/job.service'
import type { Job } from '@/types/model'
import type { AxiosResponse } from 'axios'

export const useJobStore = defineStore('job', {
  state: () => ({
    responseData: '',
    responseErrorCode: 0,
    responseError: '',
  }),

  getters: {
    // Getter untuk responseErrorCode
    getResponseErrorCode: (state) => state.responseErrorCode,

    // Getter untuk responseError
    getResponseError: (state) => state.responseError,
  },

  actions: {
    // Memuat job
    async loadJob(params: string = ''): Promise<AxiosResponse> {
      this.responseError = ''
      this.responseErrorCode = 0
      try {
        const resp = await JobService.job(params)
        this.responseData = resp.data as string
        return resp
      } catch (e: unknown) {
        if (e instanceof ResponseError) {
          this.responseError = e.errorMessage
          this.responseErrorCode = e.errorCode
        } else if (e instanceof Error) {
          this.responseError = e.message
        }
        throw e
      }
    },

    // Memuat job create input
    async loadJobCreate(params: string = ''): Promise<AxiosResponse> {
      this.responseError = ''
      this.responseErrorCode = 0
      try {
        const resp = await JobService.jobCreate(params)
        this.responseData = resp.data as string
        return resp
      } catch (e: unknown) {
        if (e instanceof ResponseError) {
          this.responseError = e.errorMessage
          this.responseErrorCode = e.errorCode
        } else if (e instanceof Error) {
          this.responseError = e.message
        }
        throw e
      }
    },

    // Memuat job input
    async loadJobData(id: number) {
      this.responseError = ''
      this.responseErrorCode = 0
      try {
        const resp = await JobService.jobData(id)
        this.responseData = resp.data as string
        return resp
      } catch (e: unknown) {
        if (e instanceof ResponseError) {
          this.responseError = e.errorMessage
          this.responseErrorCode = e.errorCode
        } else if (e instanceof Error) {
          this.responseError = e.message
        }
        throw e
      }
    },

    // Send job input
    async addJob(params: Job) {
      this.responseError = ''
      this.responseErrorCode = 0
      try {
        const resp = await JobService.jobAdd(params)
        this.responseData = resp.data as string
        return resp
      } catch (e: unknown) {
        if (e instanceof ResponseError) {
          this.responseError = e.errorMessage
          this.responseErrorCode = e.errorCode
        } else if (e instanceof Error) {
          this.responseError = e.message
        }
        throw e
      }
    },

    // Send edit job input
    async editJob(params: Job) {
      this.responseError = ''
      this.responseErrorCode = 0
      try {
        const resp = await JobService.jobEdit(params)
        this.responseData = resp.data as string
        return resp
      } catch (e: unknown) {
        if (e instanceof ResponseError) {
          this.responseError = e.errorMessage
          this.responseErrorCode = e.errorCode
        } else if (e instanceof Error) {
          this.responseError = e.message
        }
        throw e
      }
    },

    // validate job input
    async validateJob(params: Job) {
      this.responseError = ''
      this.responseErrorCode = 0
      try {
        const resp = await JobService.jobValidate(params)
        this.responseData = resp.data as string
        return resp
      } catch (e: unknown) {
        if (e instanceof ResponseError) {
          this.responseError = e.errorMessage
          this.responseErrorCode = e.errorCode
        } else if (e instanceof Error) {
          this.responseError = e.message
        }
        throw e
      }
    },

    // delete job input
    async deleteJob(id: number) {
      this.responseError = ''
      this.responseErrorCode = 0
      try {
        const resp = await JobService.jobDelete(id)
        this.responseData = resp.data as string
        return resp
      } catch (e: unknown) {
        if (e instanceof ResponseError) {
          this.responseError = e.errorMessage
          this.responseErrorCode = e.errorCode
        } else if (e instanceof Error) {
          this.responseError = e.message
        }
        throw e
      }
    },

    // restore job input
    async restoreJob(id: number) {
      this.responseError = ''
      this.responseErrorCode = 0
      try {
        const job: Job = { id }
        const resp = await JobService.jobRestore(job)
        this.responseData = resp.data as string
        return resp
      } catch (e: unknown) {
        if (e instanceof ResponseError) {
          this.responseError = e.errorMessage
          this.responseErrorCode = e.errorCode
        } else if (e instanceof Error) {
          this.responseError = e.message
        }
        throw e
      }
    },

    // delete permanent job input
    async deletePermanentJob(id: number) {
      this.responseError = ''
      this.responseErrorCode = 0
      try {
        const job: Job = { id }
        const resp = await JobService.jobDeletePermanent(job)
        this.responseData = resp.data as string
        return resp
      } catch (e: unknown) {
        if (e instanceof ResponseError) {
          this.responseError = e.errorMessage
          this.responseErrorCode = e.errorCode
        } else if (e instanceof Error) {
          this.responseError = e.message
        }
        throw e
      }
    },

    // generate invoice
    async generateInvoiceJob(params: Job) {
      this.responseError = ''
      this.responseErrorCode = 0
      try {
        const resp = await JobService.jobGenerateInvoice(params)
        this.responseData = resp.data as string
        return resp
      } catch (e: unknown) {
        if (e instanceof ResponseError) {
          this.responseError = e.errorMessage
          this.responseErrorCode = e.errorCode
        } else if (e instanceof Error) {
          this.responseError = e.message
        }
        throw e
      }
    },
  },
})
